import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

var bgimg1 = require('./../../images/background/bg6.jpg');
var bgimg2 = require('./../../images/background/cross-line2.png');

const fallbackTestimonials = [
    { image: require('./../../images/testimonials/pic1.jpg'), name: 'Ahmet Y.', role: 'Müşteri', quote: 'Kapı kalitesi ve işçilik gerçekten çok başarılı. Siparişten montaja kadar süreç oldukça düzenli ilerledi.' },
    { image: require('./../../images/testimonials/pic2.jpg'), name: 'Merve K.', role: 'Müşteri', quote: 'İletişim ve destek süreci çok hızlıydı. Ölçü alma ve montaj ekibi zamanında geldi, memnun kaldık.' },
    { image: require('./../../images/testimonials/pic3.jpg'), name: 'İsmail T.', role: 'Müşteri', quote: 'Beklediğimiz tasarım ve güvenliği bir arada bulduk. Ürün kalitesi çok iyi, tavsiye ederim.' },
    { image: require('./../../images/testimonials/pic4.jpg'), name: 'Zehra A.', role: 'Müşteri', quote: 'Fiyat-performans açısından başarılı bir tercih oldu. Montaj sonrası destekleri de çok ilgiliydi.' }
];

class Testimonials2 extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const options = {
            loop: true,
            autoplay: false,
            margin: 30,
            nav: true,
            dots: false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: { items: 1 },
                991: { items: 2 }
            }
        };

        const content = this.context?.content || {};
        const t = getTranslations(content);
        const testimonialsSection = t?.pages?.home?.testimonials || {};
        const items = Array.isArray(testimonialsSection.items) ? testimonialsSection.items : [];
        const mediaItems = getByPath(content, 'media.pages.testimonialPeople', []);

        const mergedTestimonials = (items.length ? items : fallbackTestimonials).map((item, index) => {
            const fallback = fallbackTestimonials[index] || fallbackTestimonials[fallbackTestimonials.length - 1];
            const media = (Array.isArray(mediaItems) ? mediaItems[index] : null) || {};
            return {
                image: resolveMediaSrc(media.imageUrl, fallback?.image),
                reviewername: item.name || item.reviewername || fallback?.name || '',
                position: item.role || item.position || fallback?.role || '',
                review: item.quote || item.review || fallback?.quote || '',
            };
        });

        return (
            <>
                <div className="section-full mobile-page-padding bg-repeat p-t80 p-b80" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                    <div className="section-content">
                        <div className="container">
                            <div className="section-head">
                                <div className={`${this.props.separatoralignment} sx-separator-outer`}>
                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg2 + ')' }}>
                                        <h3 className="sep-line-one">{testimonialsSection.title || 'Müşteri Yorumları'}</h3>
                                    </div>
                                </div>
                            </div>
                            <OwlCarousel className="owl-carousel testimonial-home-two owl-btn-vertical-center" {...options}>
                                {mergedTestimonials.map((item, index) => (
                                    <div className="item" key={index}>
                                        <div className="testimonial-1 hover-animation-1 bg-gray">
                                            <div className="testimonial-detail clearfix">
                                                <div className="testimonial-pic scale-in-center"><img src={item.image} alt="" width={100} height={100} /></div>
                                                <span className="testimonial-position">{item.position}</span>
                                                <h4 className="testimonial-name">{item.reviewername}</h4>
                                                <span className="fa fa-quote-right" />
                                            </div>
                                            <div className="testimonial-text">
                                                <p>{item.review}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Testimonials2;